type HandlerFunc = (event: Event) => void;

export default function preventDefault(handler?: HandlerFunc) {
  return function (event: Event): void {
    event.preventDefault();

    if (handler && typeof handler === 'function') {
      handler(event);
    }
  };
}
